// React
import React from "react";
// Material
import {Divider} from "@material-ui/core";
// Components
import {ElementsCustom} from "@components/Elements";

export const VerneFields = ({t, data, set_key_words, set_entry_phrases, updateElement, handleKeyWords}) => {
    return (
        <div className={"integration"}>
            {/* BASE URL */}
            <ElementsCustom
                t={t}
                type={"verne"}
                input_type={"input"}
                element_type={"base_url"}
                required
                element={data.info.base_url ?? ""}
                updateElement={updateElement}
            />
            <Divider/>
            {/* API KEY */}
            <ElementsCustom
                t={t}
                type={"verne"}
                input_type={"input"}
                element_type={"api_key"}
                required
                element={data.info.api_key}
                updateElement={updateElement}
            />
            <Divider/>
            {/* ENTRY PHRASES */}
            <ElementsCustom
                t={t}
                type={"verne"}
                input_type={"input_with_tags"}
                element_type={"entry_phrases"}
                required
                element={set_entry_phrases}
                elements={data.info.entry_phrases ?? []}
                updateElement={handleKeyWords}
            />
            <Divider/>
            {/* KEY WORDS */}
            <ElementsCustom
                t={t}
                type={"verne"}
                input_type={"input_with_tags"}
                element_type={"key_words"}
                required
                element={set_key_words}
                elements={data.info.back_to_bot.key_words}
                updateElement={handleKeyWords}
            />
            <Divider/>
            {/* ERROR MESSAGE */}
            <ElementsCustom
                t={t}
                type={"verne"}
                input_type={"input"}
                element_type={"error_message"}
                element={data.info.error_message ?? ""}
                updateElement={updateElement}
            />
            <Divider/>
            {/* CAPTURE */}
            <ElementsCustom
                t={t}
                type={"verne"}
                input_type={"switch"}
                element_type={"capture"}
                element={data.info.capture?.enabled ?? false}
                updateElement={updateElement}
            />
        </div>
    );
};
